import React from "react";
import { useSelector } from "react-redux";
import { userStatusColor } from "../../../base/callService/common";
import { initialStateModel } from "../../../models/model";
import { URAvatarGroup } from "../avatarGroup";
import { URStatusDot } from "../avatarGroup/statusDot";
import styles from "./atMention.module.scss";

type urMentionProps = {
  teammemberlist:any,
  appenduser:(data:any)=>void

}

function  URAtMention({teammemberlist, appenduser}:urMentionProps) {
  const { loginReducer }: initialStateModel = useSelector((state: initialStateModel) => state);
let mentionList:any=[];
mentionList=Array.isArray(teammemberlist)&& teammemberlist.filter((data:any)=>data?.sip_login_id.toString() !== loginReducer.userdetails?.sip_login_id.toString())
  const sendMentionUser = (member:any)=>{

    appenduser(member);
  };
  var len = Array.isArray(mentionList) && mentionList?.length > 7 ? Math.ceil((mentionList?.length / 8)) : 1;
  var random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
 
  return (
    <>


     
      <div className={styles.atMention}>
        <ul className={`scroller ${styles.favList}`}>

          {Array.isArray(mentionList) && mentionList?.map((member:any, index:number)=>{

            return(

              <li key ={index} onClick={()=>sendMentionUser(member)}>
                   
                   <URAvatarGroup className={`lefts size28 colorBG${random_color[index]}`}
                      profileInfo={<>  <span> {member?.first_name?.charAt(0).toUpperCase() +member?.last_name?.charAt(0).toUpperCase()} </span>
                            {member?.caller_id && <URStatusDot className={userStatusColor(member?.user_status, 'big')} />}
                      </>}
                    />
                <div className={styles.userName}>{member?.caller_id}</div>
                <div className={styles.extNum}>{member?.ext}</div>
              </li>
            );
         

          })}
          {mentionList?.length === 0 && <li>Oh,no Result Found</li> }
        </ul>
      </div>
    </>
  );
}

export {
  URAtMention
};